<template lang="pug">
    .tf_404
        .tf_404-box
            img(:src='tf404' :alt='tf404')
            .tf_content_404
                h5.title that's an error
                p The request URL / page was not found on this server
                p that's all we Know
</template>

<script>
import image from '@/assets/images/tf_404.png'
export default {
  data () {
    return {
      tf404: image
    }
  },
  created () {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex'
    document.getElementsByTagName('head')[0].appendChild(meta)
  },
  beforeDestroy () {
    const node = document.querySelector('meta[name=robots]')
    node.parentNode.removeChild(node)
  }
}
</script>

<style lang="scss">
.tf_404{
    position: relative;
    height: 58vh;
}
.tf_404-box{
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    top:50%;
    img{
        transform: translateX(-95px)
    }
    .title{
        margin-top: 15px;
        margin-bottom: 30px;
        font-family: 'MoolBoran';
        font-size: 36px;
        text-transform: uppercase;
        color: #3F342F
    }
    p{
        text-transform: uppercase;
        color: #3F342F;
        font-family: 'Montserrat';
        font-weight: bold;
        line-height: 0.5
    }
}

</style>



// WEBPACK FOOTER //
// src/components/404.vue